module.exports = __webpack_public_path__ + "static/img/mycoupons_empty.a672c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycoupons_empty.png
// module id = 7Gvm
// module chunks = 1